import { useEffect } from 'react';
import { type IFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { type GroupLayer } from '../..';
import { GroupLayerHotkeyType } from '../../type';

export function useUnpackHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        const tryGetGroupLayer = () => {
            const groupLayer = framework.service.registration.getInstance<GroupLayer>('GroupLayer');
            if (!groupLayer) {
                throw new Error('GroupLayer is not found');
            }
            return groupLayer;
        };

        framework.service.hotkey.register({
            name: $t((v) => v.Text_Ungroup),
            win: 'Shift Ctrl G',
            mac: '⇧ ⌘ G',
            key: GroupLayerHotkeyType.UNPACK,
            processors: [
                {
                    press: ['Ctrl+Shift+G', 'Command+Shift+G'],
                    fn: () => {
                        const layerId = framework.service.frame.getActiveLayer()?.id;
                        if (layerId) {
                            tryGetGroupLayer().unpack(layerId);
                        }
                    },
                },
            ],
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps -- 仅挂载时注册，与拆分前一致
    }, []);
}
